import coreUtils from "../../../assets/scripts/core-utils.js";
import jQuery from "jquery";

const $ = jQuery;

/**
*
*   This block has the library
*   http://scrollme.nckprsn.com/
*   as a dependency
*
* */

const cardHeroSection = (function($) { // eslint-disable-line

  const me = {};

  const setCardAnimations = (element) => {

    const $firstCardNotStacked = element.find('.first-card.js-animateme');
    const $secondCardNotStacked = element.find('.second-card.js-animateme');
    const $shadowNotStacked = element.find('.shadow.js-animateme');
    let animationScenario;
    let animationAttrs;

    if (element.hasClass('stacked')) {

      animationScenario = 'stacked';

    } else if (element.hasClass('single-card')) {

      animationScenario = 'single-card';

    }

    const regularAnimationAttrs = {

      firstCard: {
        'data-easing': 'easeinout',
        'data-when': 'span',
        'data-from': -0.2,
        'data-to': 0.8,
        'data-translatey': 20,
        'data-rotatez': 10,
      },

      secondCard: {
        'data-easing': 'easeinout',
        'data-when': 'span',
        'data-from': -0.2,
        'data-to': 1,
        'data-translatey': 5,
        'data-rotatez': 10,
      },

      shadow: {
        'data-easing': 'easeinout',
        'data-when': 'exit',
        'data-from': 1,
        'data-to': -0.8,
        'data-opacity': 0,
      },

    };

    const stackedAnimationAttrs = {

      firstCard: {
        'data-easing': 'easeinout',
        'data-when': 'enter',
        'data-from': -1,
        'data-to': 5,
        'data-translatey': -50,
        'data-translatex': 20,
      },

      secondCard: {
        'data-easing': 'easeinout',
        'data-when': 'enter',
        'data-from': 0,
        'data-to': 3.5,
        'data-translatey': -10,
      },

      shadow: {
        'data-easing': 'easeinout',
        'data-when': 'span',
        'data-from': -0.5,
        'data-to': 1,
        'data-opacity': 0,
      },

    };

    const singleAnimationAttrs = {

      firstCard: {
        'data-easing': 'easeinout',
        'data-when': 'span',
        'data-from': -0.2,
        'data-to': 0.8,
        'data-translatey': 40,
      },

      secondCard: {},

      shadow: {
        'data-easing': 'easeinout',
        'data-when': 'exit',
        'data-from': 1,
        'data-to': -0.8,
        'data-opacity': 0,
      },

    };

    if (animationScenario === 'stacked') {

      animationAttrs = stackedAnimationAttrs;

    } else if (animationScenario === 'single-card') {

      animationAttrs = singleAnimationAttrs;

    } else {

      animationAttrs = regularAnimationAttrs;

    }

    $firstCardNotStacked.attr(animationAttrs.firstCard);
    $secondCardNotStacked.attr(animationAttrs.secondCard);
    $shadowNotStacked.attr(animationAttrs.shadow);

  };

  const scrollFromHero = () => {

    $('.js-down').on('click', (e) => {

      e.preventDefault();

      // Next element that contains classname "-section"
      // and not containing "hero"
      // this is getting around the wrapping <div> by Epi
      const scrollTo = $("div[class*='-section']:not(div[class*='hero'])");

            coreUtils.autoScroll(scrollTo, 1500); // eslint-disable-line

    });

  };

  me.init = () => {

    $('.card-hero-section').each(function() {

      // Populate config on DOM elements that
      // scrollme.js should detect and use
      setCardAnimations($(this));

    });

    scrollFromHero();

  };

  return me;

}(jQuery)); // eslint-disable-line

export default cardHeroSection;
